(() => {
  if (window.ellaReferralCartReady) return;
  window.ellaReferralCartReady = true;
  const selector = '[data-ella-referral-code]';
  const normalize = value => String(value || '').trim().toUpperCase();
  let wanted = null;
  let remember = false;
  let saved = null;
  let revision = 0;
  let savedRevision = -1;
  let pending = null;
  let timer;
  const fields = () => [...document.querySelectorAll(selector)];
  function status(message) {
    document.querySelectorAll('[data-ella-referral-status]').forEach(node => { node.textContent = message; });
  }
  function sync(value) {
    fields().forEach(input => { if (input.value !== value) input.value = value; });
  }
  async function persist() {
    if (pending) return pending;
    if (wanted === null || savedRevision === revision) return;
    pending = (async () => {
      while (savedRevision !== revision) {
        const value = wanted;
        const version = revision;
        const rememberValue = remember;
        status('');
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({attributes: {'ELLA Partnerkennung': value, 'ELLA Empfehlungsauswahl': 'Manuell', 'ELLA Partner merken': rememberValue ? 'Ja' : ''}})
        });
        if (!response.ok) throw new Error('referral_save');
        const cart = await response.json();
        if (normalize(cart.attributes?.['ELLA Partnerkennung']) !== value || (cart.attributes?.['ELLA Partner merken'] === 'Ja') !== rememberValue) throw new Error('referral_verify');
        saved = value;
        savedRevision = version;
      }
      status('');
    })();
    try { await pending; }
    catch (error) {
      status('Die Partnerkennung konnte nicht gespeichert werden. Bitte versuche es erneut.');
      throw error;
    } finally { pending = null; }
  }
  document.addEventListener('input', event => {
    if (!event.target.matches(selector)) return;
    remember = !!event.target.closest('form')?.querySelector('[data-ella-referral-remember]')?.checked;
    wanted = normalize(event.target.value);
    revision++;
    fields().filter(input => input !== event.target).forEach(input => { input.value = wanted; });
    clearTimeout(timer);
    timer = setTimeout(() => { persist().catch(() => {}); }, 400);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ella-referral-remember]')) {
      remember = event.target.checked;
      document.querySelectorAll('[data-ella-referral-remember]').forEach(input => { input.checked = remember; });
      wanted = normalize(event.target.closest('form').querySelector(selector).value);
      revision++;
      clearTimeout(timer);
      persist().catch(() => {});
      return;
    }
    if (!event.target.matches(selector)) return;
    wanted = normalize(event.target.value);
    revision++;
    sync(wanted);
    clearTimeout(timer);
    persist().catch(() => {});
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    const input = form.querySelector?.(selector);
    if (!input || form.dataset.ellaReferralSubmitting === 'true') return;
    // Native form POST remains the fallback without JavaScript. With JavaScript,
    // finish any outstanding Ajax write before allowing navigation to checkout.
    const value = normalize(input.value);
    if (wanted === null) { wanted = value; saved = value; savedRevision = revision; }
    if (!pending && savedRevision === revision) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter;
    if (form.dataset.ellaReferralWaiting === 'true') return;
    form.dataset.ellaReferralWaiting = 'true';
    clearTimeout(timer);
    persist().then(() => {
      sync(wanted);
      form.dataset.ellaReferralSubmitting = 'true';
      try { form.requestSubmit(submitter || undefined); }
      finally { delete form.dataset.ellaReferralSubmitting; }
    }).catch(() => { input.focus(); }).finally(() => { delete form.dataset.ellaReferralWaiting; });
  }, true);
})();
